export default __webpack_public_path__ + "static/media/foodBack.4960c119.jpeg";